import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { SidebarContent } from './Sidebar';
import { Sheet, SheetContent, SheetTitle } from './ui/sheet';
import { Menu, Plus, Home, Users, CalendarDays, FileSignature, Wine } from 'lucide-react';
import { cn } from '../lib/utils';

const TABS = [
  { id: 'home', label: 'Home', Icon: Home, table: 'guests', view: 'dashboard' },
  { id: 'guests', label: 'Guests', Icon: Users, table: 'guests', view: 'grid' },
  { id: 'calendar', label: 'Calendar', Icon: CalendarDays, table: 'guests', view: 'calendar' },
  { id: 'releases', label: 'Releases', Icon: FileSignature, table: 'releases' },
];

function MenuDrawer({ open, onOpenChange }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-[290px] p-0 overflow-y-auto" data-testid="mobile-menu-drawer">
        <SheetTitle className="sr-only">Navigation</SheetTitle>
        <SidebarContent onNavigate={() => onOpenChange(false)} />
      </SheetContent>
    </Sheet>
  );
}

export function MobileHeader({ onAdd }) {
  const { activeShow } = useApp();
  const [open, setOpen] = useState(false);
  return (
    <header className="md:hidden flex items-center gap-2 px-3 h-12 border-b border-stone-200 bg-[#FAF7F2] pt-[env(safe-area-inset-top)]" data-testid="mobile-header">
      <button data-testid="mobile-menu-btn" onClick={() => setOpen(true)} className="h-9 w-9 grid place-items-center rounded-md text-stone-700 hover:bg-stone-200/60 active:scale-95 transition-transform" aria-label="Open menu">
        <Menu className="w-5 h-5" />
      </button>
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <span className="h-6 w-6 rounded grid place-items-center text-white shrink-0" style={{ background: activeShow.color }}><Wine className="w-3.5 h-3.5" /></span>
        <span className="text-[14px] font-semibold text-stone-900 truncate">{activeShow.name}</span>
      </div>
      <button data-testid="mobile-add-btn" onClick={onAdd} className="h-9 w-9 grid place-items-center rounded-full text-white shadow-sm active:scale-95 transition-transform" style={{ background: activeShow.color }} aria-label="New guest or prospect">
        <Plus className="w-5 h-5" />
      </button>
      <MenuDrawer open={open} onOpenChange={setOpen} />
    </header>
  );
}

export function MobileTabBar() {
  const { activeTable, activeView, setActiveTable, setActiveView, activeShow } = useApp();
  const [open, setOpen] = useState(false);
  const isActive = (t) => activeTable === t.table && (!t.view || activeView === t.view);
  const go = (t) => { setActiveTable(t.table); if (t.view) setActiveView(t.view); };
  const otherActive = !TABS.some(isActive);

  return (
    <nav className="md:hidden shrink-0 border-t border-stone-200 bg-white/95 backdrop-blur pb-[env(safe-area-inset-bottom)]" data-testid="mobile-tab-bar">
      <div className="grid grid-cols-5 h-14">
        {TABS.map(t => {
          const active = isActive(t);
          return (
            <button key={t.id} data-testid={`mobile-tab-${t.id}`} onClick={() => go(t)} className="flex flex-col items-center justify-center gap-0.5 text-[10.5px] font-medium transition-colors active:scale-95" style={{ color: active ? activeShow.color : '#78716c' }}>
              <t.Icon className={cn('w-5 h-5', active && 'drop-shadow-sm')} strokeWidth={active ? 2.4 : 1.8} />
              {t.label}
            </button>
          );
        })}
        <button data-testid="mobile-tab-more" onClick={() => setOpen(true)} className="flex flex-col items-center justify-center gap-0.5 text-[10.5px] font-medium active:scale-95" style={{ color: otherActive ? activeShow.color : '#78716c' }}>
          <Menu className="w-5 h-5" strokeWidth={otherActive ? 2.4 : 1.8} />
          More
        </button>
      </div>
      <MenuDrawer open={open} onOpenChange={setOpen} />
    </nav>
  );
}
